
import { Component, Vue, Watch } from "vue-property-decorator";
import * as echarts from "echarts";
import {
  DashTopData,
  PeopleData,
  TimeData,
  AllExam,
  ecOptionLD,
  ecOptionLong,
  AddAlways,
  DataWatch,
  ExamWatch
} from "@/lib/dash/dash-v3";
import Auth from "@/lib/common/auth";
import { ExamGetForm, UploadParamsForm } from "@/lib/form/exam/ExamListForm";
import ExamList from "@/lib/model/exam/exam";
import ModalTitle from "@/lib/model/exam/modal-title";
import ModalHeader from "@/components/modal-header.vue";
import ExamLink from "@/views/exam-v3/components/exam-link.vue";
import vuexStore from "@/store/vuex-store";

import {
  CandidateMCreateParams,
  CandidateMCreateParseParams
} from "@/lib/model/exam/candidate";
import CandidateCreateForm, {
  StructParam
} from "@/lib/form/candidate/CandidateCreateForm";
import AddOneCandidateModal from "@/views/paper/components/add-one-candidate-new.vue";
import AddMoreCandidateModal from "@/views/paper/components/add-more-candidate-new.vue";
import Loading from "@/components/loading.vue";
import {
  ExamVDList,
  ExamVDListRequest
} from "@/lib/model/exambuilder/exam-v3/exam-v3";
@Component({
  components: {
    ModalHeader,
    ExamLink,
    AddOneCandidateModal,
    AddMoreCandidateModal,
    Loading
  }
})
export default class Dash extends Vue {
  showExamLink = false;
  hasNoExam = false; //公司全部数据均为空
  textList = [
    {
      title: "抢人更快",
      text: "可同时面试数十万人，缩短招聘周期，提高到面率",
      icon: `&#xe717;`
    },
    {
      title: "统一招聘标准",
      text:
        "根据企业个性化招聘要求，组合确定出岗位能力模型，统一标准，评估更精准",
      icon: `&#xe715;`
    },
    {
      title: "招聘降本增效",
      text:
        "借助AI面试优化招聘流程，避免重复劳动和反复沟通，面试官和HR省心省力",
      icon: `&#xe718;`
    },
    {
      title: "打造雇主品牌",
      text: "面试官形象好，面试问题精心打磨，候选人应聘体验更佳",
      icon: `&#xe716;`
    }
  ];

  cancelAdd() {
    this.showExamLink = false;
    this.inEdit = false;
    this.beginTimer();
    this.getCurrentExamInfo();
  }
  //获取公司下面试数量
  getExamNum() {
    ExamVDList.getList(new ExamVDListRequest()).then(res => {
      console.log(res);
      this.hasNoExam = res.count === 0;
    });
  }
  async showAddDialog() {
    this.inEdit = true;
    this.stopTimer();
    const params = {
      examId: this.currentExam.examId,
      companyId: parseInt(Auth.companyId)
    };

    const wsaRes = await ExamList.wsaCode(params);

    if (wsaRes.code !== 0) return;

    this.showExamLink = true;
    this.scanLink = wsaRes.data.base64string
      ? `data:image/png;base64,${wsaRes.data.base64string}`
      : "";

    const urlRes = await ExamList.examUrl(params);

    if (urlRes.code !== 0) return;

    this.scanUrl = urlRes.data.url;

    return;
  }

  ecOptionLD = ecOptionLD; //ec配置
  ecOptionLong = ecOptionLong; //
  alwaysExamList: any = []; //常用面试列表
  currentExam: any = {}; //当前常用面试
  currentExamIndex = 0; //当前常用面试角标
  currentExamInfo: any = {}; //当前常用面试人数信息
  topData = new DashTopData(); //顶部卡片数据
  peopleData = new PeopleData(); //漏斗数据
  timeData = new TimeData(); //时长数据
  allExam = new AllExam(); //全部面试
  searchInputValue = "";
  timeDur = 7;
  selectExamId = "0";
  bottomTimeDur = 7;
  bottomSelectExamId = "0";
  show = false;
  V = vuexStore;

  searchText = ""; //弹窗搜索常
  selectedExamList: any = []; //弹窗已选

  //展示二维码相关
  examGetForm: ExamGetForm = new ExamGetForm();
  link = "";
  scanLink = "";
  scanUrl = "";
  modalTitle: ModalTitle = new ModalTitle();
  showExamUrl = false;
  currentPaperId = 0;
  examName = "";
  examRemark = "";

  //添加候选人相关
  uploadParams = new UploadParamsForm();
  candidateMCreateParseParams = new CandidateMCreateParseParams();
  candidateMCreateParams = new CandidateMCreateParams();
  candidateCreateForm = new CandidateCreateForm();
  isShowAddMore = false;
  isShowAddOne = false;
  structParams: StructParam[] = new Array<StructParam>();
  clickAlwaysExamId = 0;

  //新功能引导
  newTip = [true, false, false, false];
  newGuide = false; //是否走新手引导流程
  loadingTop = true;
  loading3 = true;
  loadingToday = true;

  getCurrentExamInfo() {
    return ExamWatch.get({
      companyId: Number(Auth.companyId),
      examId: this.currentExam.examId
    }).then(res => {
      this.currentExamInfo = res;
    });
  }

  preExam() {
    // this.loading3 = true;
    this.currentExamIndex--;
    if (this.currentExamIndex < 0) {
      this.currentExamIndex = this.alwaysExamList.length - 1;
    }
    this.currentExam = this.alwaysExamList[this.currentExamIndex];
    this.getCurrentExamInfo().then(() => {
      // this.loading3 = false;
    });
  }
  nextExam() {
    // this.loading3 = true;
    // const now = new Date().getTime();
    this.currentExamIndex++;
    if (this.currentExamIndex >= this.alwaysExamList.length) {
      this.currentExamIndex = 0;
    }
    this.currentExam = this.alwaysExamList[this.currentExamIndex];
    this.getCurrentExamInfo().then(() => {
      // if (new Date().getTime() - now > 500) {
      //   this.loading3 = false;
      // } else {
      //   setTimeout(() => {
      //     this.loading3 = false;
      //   }, 500 - (new Date().getTime() - now));
      // }
    });
  }
  timer: any = null;
  //自动播放常用面试
  autoPlayExam() {
    if (this.timer) return;
    if (this.alwaysExamList.length < 2) return;
    this.timer = window.setInterval(() => {
      this.nextExam();
    }, 5000);
  }
  beforeDestroy() {
    this.stopTimer();
  }
  stopTimer() {
    window.clearInterval(this.timer);
    this.timer = null;
  }
  inEdit = false;
  beginTimer() {
    if (this.inEdit) return;
    this.autoPlayExam();
  }

  //下拉搜索匹配
  get getOptions() {
    if (this.searchInputValue) {
      const t = this.allExam.list.filter(d =>
        d.name.includes(this.searchInputValue)
      );
      return [...t];
    } else {
      return [...this.allExam.list];
    }
  }

  //弹窗搜索匹配
  get getOptionsAlways() {
    if (this.searchText) {
      const t = this.allExam.list.filter(d => d.name.includes(this.searchText));

      return t;
    } else {
      return this.allExam.list;
    }
  }
  //弹窗选中样式
  ed(d: any) {
    let flag = false;
    this.selectedExamList.map((m: any, i: number) => {
      if (m.examId === d.examId) {
        flag = true;
        return;
      }
    });
    return flag;
  }

  created() {
    if (Auth.token) {
      const thisIsAGetLikeSet = Auth.companyId; //触发一下
      this.getExamNum();
      console.log(thisIsAGetLikeSet);
      this.getAllData();

      //新手引导
      // if (localStorage.getItem("showNewTip") !== "1") {
      //   this.newGuide = true;
      // }
      //未登录
    } else {
      this.$router.push("/").catch(err => err);
    }
  }

  allLoading = false;
  //加载所有数据
  getAllData() {
    //头部卡片信息
    this.allLoading = true;
    Promise.all([
      this.getTop(),
      this.getLD(),
      TimeData.get(Number(Auth.companyId)).then(res => {
        this.timeData = res;
        this.getDataWatch();
      }),
      AllExam.get(Number(Auth.companyId)).then(res => {
        this.allExam = res;
      })
    ]).then(res => {
      if (this.alwaysExamList.length) {
        this.getCurrentExamInfo().then(() => {
          this.loading3 = false;
          this.allLoading = false;
          this.$nextTick(() => {
            this.setEchartLD();
          });
        });
      } else {
        this.allLoading = false;
        this.$nextTick(() => {
          this.setEchartLD();
        });
      }
    });
  }
  //左侧漏斗交互
  selectLD(str: string) {
    this.ecOptionLD.legend.selected[str] = !this.ecOptionLD.legend.selected[
      str
    ];
    this.setEchartLD();
  }
  //顶部信息
  async getTop() {
    return DashTopData.get(Number(Auth.companyId)).then(res => {
      this.topData = res;
      this.loadingTop = false;
      this.alwaysExamList = res.examCommonlyUsedList;
      if (this.alwaysExamList.length) {
        this.currentExam = this.alwaysExamList[0];
        this.currentExamIndex = 0;
        this.selectedExamList = JSON.parse(JSON.stringify(this.alwaysExamList));
        this.getCurrentExamInfo().then(() => {
          this.autoPlayExam();
        });
      } else {
        this.selectedExamList = [];
        this.currentExamIndex = 0;
        this.currentExam = {};
        this.loading3 = false;
      }
    });
  }
  //获取漏斗
  async getLD() {
    return PeopleData.get(
      Number(Auth.companyId),
      Number(this.selectExamId),
      Number(this.timeDur)
    ).then(res => {
      this.peopleData = res;
      this.ecOptionLD.legend.selected = {
        新增候选人数: true,
        填写信息人数: true,
        完成面试人数: true,
        通过人数: true
      };
    });
  }
  //漏斗EC
  setEchartLD() {
    //
    if (!this.$refs.ecLD) return;
    const echart = echarts.init(this.$refs.ecLD as any);
    if (echart) {
      echart.clear();
      this.ecOptionLD.xAxis[0].data = this.peopleData.detail.headers;
      this.ecOptionLD.series[0].data = this.peopleData.detail.rowCreate;
      this.ecOptionLD.series[1].data = this.peopleData.detail.rowLogin;
      this.ecOptionLD.series[2].data = this.peopleData.detail.rowSubmitFinish;
      this.ecOptionLD.series[3].data = this.peopleData.detail.rowAuditPass;
      echart.setOption(this.ecOptionLD);
      echart.on("legendselectchanged", (p: any) => {
        console.log(p);
        this.ecOptionLD.legend.selected = p.selected;
      });
      window.addEventListener("resize", () => {
        echart.resize();
      });
    }
  }
  // showBottomEchart = false; //展示底部图表
  showEX = false; //展示图例
  heighTime = ""; //最高时间段
  //时间段数据 监控
  getDataWatch() {
    DataWatch.get({
      companyId: Number(Auth.companyId),
      examId: Number(this.bottomSelectExamId),
      daysLimit: Number(this.bottomTimeDur)
    }).then(res => {
      // this.ecOptionLong.xAxis[0].data = res.byBeginTime.headers;
      const dataList: any[] = [];
      let firstTimeIndex = -1;
      let hasDataTimer = 0; //有做答数据的时间段数量
      res.byBeginTime.row.forEach((d: any, index: number) => {
        dataList.push({
          value: d.all,
          other: d,
          itemStyle: {
            //第一 前五十 后五十 倒数第一 色号
            color:
              d.flag === "first"
                ? "#16A370"
                : d.flag === "after"
                ? "rgba(22,163,112,0.5)"
                : d.flag === "behind"
                ? "rgba(230,58,14,0.6)"
                : d.flag === "last"
                ? "#E63A0E"
                : "#16A370"
          }
        });
        if (d.flag === "first") {
          firstTimeIndex = index;
        }
        if (d.all > 0) {
          hasDataTimer++;
        }
      });

      this.heighTime =
        firstTimeIndex > -1 ? res.byBeginTime.headers[firstTimeIndex] : "";
      this.showEX = hasDataTimer > 3;
      this.ecOptionLong.series[0].data = dataList;
      if (!this.$refs.ecLong) return;
      const echart = echarts.init(this.$refs.ecLong as any);
      if (echart) {
        echart.setOption(this.ecOptionLong);
        window.addEventListener("resize", () => {
          echart.resize();
        });
      }
    });
  }
  //面试各类人数 监控
  showAlways() {
    this.inEdit = true;
    this.stopTimer();
    this.show = true;
  }

  //选择面试
  selectExam() {
    this.getLD().then(() => {
      this.setEchartLD();
    });
  }
  selectExamBottom() {
    this.getDataWatch();
  }

  //头像缺失
  defImg(event: any) {
    //
  }
  //漏斗百分比
  countPercent(num: number, father: number) {
    const t = Math.floor((num / father) * 100);
    return t || 0;
  }
  //头像数量处理
  getSix(list: any) {
    return list.length > 6 ? list.slice(0, 6) : list;
  }
  //弹窗选中面试
  addAlwaysExam(item: any) {
    const i = this.selectedExamList.findIndex(
      (d: any) => d.examId === item.examId
    );
    if (i !== -1) {
      this.selectedExamList.splice(i, 1);
      this.$forceUpdate();
    } else {
      if (this.selectedExamList.length < 6) {
        this.selectedExamList.push(item);
        this.$forceUpdate();
      } else {
        this.$message.warning("最多可设置6个常用面试");
      }
    }
  }
  //保存常用面试
  okAlways() {
    const params: any = {};
    params.companyId = Auth.companyId;
    params.commonlyUsedExamIdList = this.selectedExamList.map((d: any) => {
      return d.examId;
    });
    AddAlways.set(params).then(() => {
      this.$message.success("修改成功");
      this.show = false;
      this.inEdit = false;
      this.getTop();
      this.beginTimer();
    });
  }
  close() {
    this.show = false;
    this.inEdit = false;
    this.beginTimer();
    setTimeout(() => {
      this.selectedExamList = JSON.parse(JSON.stringify(this.alwaysExamList));
    }, 500);
  }
  //跳转候选人列表
  toPage(key: string) {
    if (key === "export") {
      //导出
      this.$router.push("/export/list");
    } else if (key === "email") {
      //邮件
      this.$router.push("/message/list");
    } else if (key === "mobile") {
      //短信
      this.$router.push("/message/list");
    } else if (key === "list") {
      //面试列表
      this.$router.push("/exam/list");
    } else if (key === "peopleList") {
      //候选人列表
      this.$router.push("/candidate/list");
    } else if (key === "builder") {
      //新建面试
      this.$router.push("/aihr-builder");
    }
  }
  //指定面试
  toPageExam(item: any) {
    this.$router.push({
      name: "exam-candidate",
      query: {
        paperId: item.examId
      }
    });
  }
  //数值 1w+
  formatNumber(n: string | number) {
    n = String(n);
    const num = parseInt(n, 10);
    if (isNaN(num)) {
      return n;
    }
    if (num < 10000) {
      return n;
    }
    return `${(num / 10000).toFixed(1)}w+`;
  }

  //展示面试二维码
  showQRCode(row: any) {
    this.modalTitle.hasDesc = true;
    this.modalTitle.desc = row.name;
    this.examName = row.name;
    this.examRemark = row.remark;
    this.currentPaperId = row.examId;
    // 面试链接dialog
    this.examGetForm.examId = row.examId;
    this.examGetForm.companyId = parseInt(Auth.companyId);
    this.showExamUrl = true;
    ExamList.wsaCode(this.examGetForm)
      .then(res => {
        if (res.code === 0) {
          this.scanLink = "data:image/png;base64," + res.data.base64string;
          // this.scanUrl = `${Config.aiInterviewHost}/exam/sign?connectCode=${row.connectCode}`;
          this.modalTitle.title = "面试链接";
        }
      })
      .then(() => {
        ExamList.examUrl(this.examGetForm).then(urlRes => {
          if (urlRes.code === 0) {
            this.scanUrl = urlRes.data.url;
          }
        });
      });
  }

  //添加候选人
  showAdd(event: string, row: ExamList) {
    this.modalTitle.desc = row.name;
    this.examName = row.name;
    this.examRemark = row.remark;
    this.examGetForm.examId = row.examId;
    this.examGetForm.companyId = parseInt(Auth.companyId);
    this.uploadParams.ucCompanyId = parseInt(Auth.companyId);
    this.uploadParams.examId = row.examId;
    this.candidateMCreateParseParams.companyId = parseInt(Auth.companyId);
    this.candidateMCreateParseParams.examId = row.examId;
    this.candidateMCreateParams.examId = String(row.examId);
    this.candidateMCreateParams.companyId = Auth.companyId;
    this.clickAlwaysExamId = Number(row.examId);
    if (event == "showAddOne") {
      this.modalTitle.title = "添加一位候选人";
      ExamList.examGet(this.examGetForm)
        .then(res => {
          this.candidateCreateForm.paramList = res.paramList.filter(
            (e: StructParam) => {
              return e.isShow == 1;
            }
          );
          this.candidateCreateForm.companyId = this.examGetForm.companyId;
          this.candidateCreateForm.examId = this.examGetForm.examId;
        })
        .finally(() => {
          this.isShowAddMore = false;
          this.isShowAddOne = true;
        });
    } else if (event === "showAddMore") {
      this.modalTitle.title = "批量添加候选人";
      this.isShowAddOne = false;
      this.isShowAddMore = true;
    }
  }
  //关闭弹窗
  handleMoreClose() {
    this.isShowAddOne = false;
    this.isShowAddMore = false;
  }

  addSubmit() {
    this.isShowAddOne = false;
  }
  //引导下一步
  guideNext(i: number) {
    this.newTip[i] = false;
    this.newTip[i + 1] = true;
    this.$forceUpdate();
  }
  //引导上一步
  guidePre(i: number) {
    this.newTip[i] = false;
    this.newTip[i - 1] = true;
    this.$forceUpdate();
  }
  //新手引导完毕
  guideOver() {
    localStorage.setItem("showNewTip", "1");
    this.newGuide = false;
  }
}
